import { render, staticRenderFns } from "./new-solo-driver-form.vue?vue&type=template&id=198213ed&"
import script from "./new-solo-driver-form.vue?vue&type=script&lang=js&"
export * from "./new-solo-driver-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports